import { TicketingFormCategory } from "@simplyk/common";

import { Translate } from "@/common/hooks/useTranslate";

interface TicketingTitleStepWording {
  stepTitle: string;
  stepDescription: string;
}

export const getTicketingDescriptionStepWording = (
  t: Translate,
  category: TicketingFormCategory
): TicketingTitleStepWording => {
  switch (category) {
    case TicketingFormCategory.Event:
      return {
        stepTitle: t("dashboard", "ticketing.setEventDescription.event.title"),
        stepDescription: t("dashboard", "ticketing.setEventDescription.event.description"),
      };
    case TicketingFormCategory.Shop:
      return {
        stepTitle: t("dashboard", "ticketing.setEventDescription.shop.title"),
        stepDescription: t("dashboard", "ticketing.setEventDescription.shop.description"),
      };
    case TicketingFormCategory.Auction:
      return {
        stepTitle: t("dashboard", "ticketing.setEventDescription.auction.title"),
        stepDescription: t("dashboard", "ticketing.setEventDescription.auction.description"),
      };
    case TicketingFormCategory.Lottery:
      return {
        stepTitle: t("dashboard", "ticketing.setEventDescription.lottery.title"),
        stepDescription: t("dashboard", "ticketing.setEventDescription.lottery.description"),
      };
    case TicketingFormCategory.Sweepstakes:
      return {
        stepTitle: t("dashboard", "ticketing.setEventDescription.sweepstakes.title"),
        stepDescription: t("dashboard", "ticketing.setEventDescription.sweepstakes.description"),
      };
    case TicketingFormCategory.MembershipV2:
      return {
        stepTitle: t("dashboard", "ticketing.setEventDescription.membership.title"),
        stepDescription: t("dashboard", "ticketing.setEventDescription.membership.description"),
      };
    case TicketingFormCategory.Custom:
    default:
      return {
        stepTitle: t("dashboard", "ticketing.setEventDescription.custom.title"),
        stepDescription: t("dashboard", "ticketing.setEventDescription.custom.description"),
      };
  }
};

export const prefillDescription = (
  t: Translate,
  organizationName: string | undefined,
  category: TicketingFormCategory
) => {
  const boldOrgName = `<strong>${organizationName}</strong>`;
  switch (category) {
    case TicketingFormCategory.Event:
      return `
    <p>🎉 ${t("dashboard", "ticketing.prefilledDescription1", { boldOrgName })} 🎉</p>
    <p></p>
    <p>${t("dashboard", "ticketing.prefilledDescription2")}</p>
    <p></p>
    <p>${t("dashboard", "ticketing.prefilledDescription3")}</p>
    `;
    case TicketingFormCategory.Custom:
      return `
    <p>🎉 ${t("dashboard", "ticketing.prefilledDescription1.custom", { boldOrgName })} 🎉</p>
    <p></p>
    <p>${t("dashboard", "ticketing.prefilledDescription2.custom")}</p>
    <p></p>
    <p>${t("dashboard", "ticketing.prefilledDescription3")}</p>
    `;
    case TicketingFormCategory.Shop:
      return `
    <p>${t("dashboard", "ticketing.prefilledDescription1.shop")}</p>
    <p></p>
    <p>${t("dashboard", "ticketing.prefilledDescription2.shop")}</p>
    <p></p>
    <p>${t("dashboard", "ticketing.prefilledDescription3.shop")}</p>
    <p></p>
    <p>${t("dashboard", "ticketing.prefilledDescription4.shop")}</p>
    <p></p>
    <p>${organizationName}</p>
    `;
    case TicketingFormCategory.Lottery:
      return `
    <p>${t("dashboard", "ticketing.raffleDescriptionPrefill1")}</p>
    <p></p>
    <p>${t("dashboard", "ticketing.raffleDescriptionPrefill2")}</p>
    `;
    case TicketingFormCategory.Sweepstakes:
      return `
    <p>${t("dashboard", "sweepstakes.description.default", { organizationName: organizationName || "" })}</p>
    `;
    case TicketingFormCategory.MembershipV2:
      return `
    <p>${t("dashboard", "ticketing.prefilledMembershipDescription1")}</p>
    <p></p>
    <p>${t("dashboard", "ticketing.prefilledMembershipDescription2")}</p>
    <p></p>
    <p>${t("dashboard", "ticketing.prefilledMembershipDescription3")}</p>
    `;
    case TicketingFormCategory.Auction:
      return `
      <p>${t("dashboard", "ticketing.auctionDescriptionPrefill1")}</p>
      <p />
      <p>${t("dashboard", "ticketing.auctionDescriptionPrefill2")}</p>
      <p />
      <p>${t("dashboard", "ticketing.auctionDescriptionPrefill3")}</p>
      <p />
      <p>${organizationName}</p>
      `;
    default:
      return `
    <p>🎉 ${t("dashboard", "ticketing.prefilledDescription1", { boldOrgName })} 🎉</p>
        <p></p>
    <p>${t("dashboard", "ticketing.prefilledDescription2")}</p>
    <p></p>
    <p>${t("dashboard", "ticketing.prefilledDescription3")}</p>
    `;
  }
};
